import {useEffect, useMemo, useRef} from 'react'
import useAutocomplete from '../../google-maps-api/hooks/useAutocomplete'
import useEffectEvent from '../../hooks/use-effect-event'

const useAutocompleteFindStoreFields = (form, {onPlaceSelected}) => {
    const isMounted = useRef(true)
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const autocompleteOptions = useMemo(
        () =>
            /** @type google.maps.places.AutocompleteOptions */ ({
                fields: ['name', 'geometry'],
                strictBounds: true
            }),
        []
    )
    const {ref, place} = useAutocomplete(autocompleteOptions)
    const onPlaceFound = useEffectEvent((place) => {
        form.setValue('address', place.name, {shouldValidate: true})
        if (place.geometry?.location) {
            form.setValue('latitude', place.geometry.location.lat(), {shouldValidate: false})
            form.setValue('longitude', place.geometry.location.lng(), {shouldValidate: false})
            onPlaceSelected?.(place)
        } else {
            const input = ref.current
            const fallbackAddress = place.name || input?.value
            if (window.google?.maps) {
                const geocoder = new window.google.maps.Geocoder()
                geocoder.geocode({address: fallbackAddress}, (results, status) => {
                    if (status === 'OK' && results?.[0]?.geometry?.location) {
                        if (isMounted.current) {
                            const location = results[0].geometry.location
                            form.setValue('latitude', location.lat(), {shouldValidate: false})
                            form.setValue('longitude', location.lng(), {shouldValidate: false})
                            onPlaceSelected?.(place)
                        }
                    }
                })
            }
        }
    })
    useEffect(() => {
        if (!place || !place.name) {
            return
        }

        onPlaceFound(place)
    }, [place, onPlaceFound])

    return {ref}
}

export default useAutocompleteFindStoreFields
